<template>

  <div class="height-100">
    <VideoEmbed
      :roomId="token" />
  </div>

</template>

<script>
import VideoEmbed from './VideoEmbed.vue'
import axios from 'axios'
import config from '../../config'
import cookie from 'js-cookie'
const axiosInstance = axios.create({
  baseURL: config.api_url,
  json: true
})

export default {
  name: 'Meet',
  components: {
    VideoEmbed
  },
  data () {
    return {
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    callUrl () {
      return `https://quickin.daily.co/novoteste`
    }
  },
  mounted () {
    this.getContext().then(res => {
      const {
        candidateId,
        jobId,
        accountId
      } = res

      this.$router.push(`/job/${jobId}?candidate_id=${candidateId}&candidate_job_id=${jobId}&account_id=${accountId}&meet_token=${this.token}`)
    }).catch(() => {
      this.startMeet()
    })
  },
  methods: {
    getContext () {
      const token = cookie.get('access_token')
      const headers = { Authorization: `Bearer ${token}` }
      return axiosInstance.get(`/meet-context/${this.token}`, { headers }).then(context => {
        const {
          candidate_id: candidateId,
          job_id: jobId,
          account_id: accountId
        } = context.data
        // verificar se tem acesso à vaga
        return axiosInstance.get(`/accounts/${accountId}/jobs/${jobId}`, { headers }).then(() => {
          return {
            candidateId,
            jobId,
            accountId
          }
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Meet/Meet.vue